const ContentServerClient = require("./../ContentServerClient.js");

class ExportUtil {

    constructor(){
    }
    
    getModel(handleError, id, name, type, version){
        switch (type) {
            case "STEP": return this.getStatus(handleError, id, "model")
                                    .then(() => ContentServerClient.get3DModelTranslation(handleError, id))
                                    .then(response => this.responseModel(response, `${name}.step`));
            case "OBJ": return this.getStatus(handleError, id, "f3d")
                                    .then(() => ContentServerClient.get3DModelTranslation(handleError, id, "obj"))
                                    .then(response => this.responseModel(response, `${name}.obj`))
                                    .then(() => ContentServerClient.get3DModelTranslation(handleError, id, "mtl"))
                                    .then(response => this.responseModel(response, `${name}.mtl`))
            case "F3D": return this.getStatus(handleError, id, "f3d")
                                    .then(() => ContentServerClient.get3DModelTranslation(handleError, id, "f3d"))
                                    .then(response => this.responseModel(response, `${name}.f3d`))
            default: return this.makeLbrLink(ContentServerClient.getPackageExportLink(id, version)); 
        }
    }

    getStatus(handleError, id, type){
        return new Promise((resolve, reject) => this.getAssetModelStatus(handleError, resolve, reject, id, type));
    }

    pollImportStatus(handleError, resolve, id, type) {
        setTimeout(() => this.getAssetModelStatus(handleError, resolve, reject, id, type), 1000);
    };

    getAssetModelStatus(handleError, resolve, reject, id, type) {
        ContentServerClient.getModelStatus(handleError, id, type)
            .then((response) => {
                switch (true) {
                    case response && response.status === "complete":
                        resolve(id)
                    break;
                    case response && response.status === "failed":
                        handleError(null, "get this translation", `Translations failed for this model.  This model is considered corrupt.`);
                        throw new Error();
                    break;
                    default: {
                        handleError(null, "", `Translations are still in progress for this model.  Please try again shortly.`)
                        throw new Error();
                    }
                }
            })
            .catch(err => reject(`The network has a problem`))
    }
    
    makeLbrLink(link){
        return new Promise((resolve, reject) => {
            var a = document.createElement("a");
            a.href = link;
            a.download = "file.lbr";
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a); 
                //Close the Spinning 
                resolve(false)}, 0); 
        })
    }

    async exportLibrary(handleError, library){
        try {
            await ContentServerClient.exportLibrary(handleError, library);
        } catch (error) {
            console.error('Error ExportUtil exportLibrary', error);
        }
    }
    
    responseModel(response, name){
        return response.blob()
                .then(data => this.makeBlodLink(data, name))
                .catch(error => {throw error})
    }

    makeBlodLink(data, name){
        var a = document.createElement("a"),
        blob = new Blob([data]);
        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(blob, name);
        else { // Others
            var url = URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {document.body.removeChild(a); window.URL.revokeObjectURL(url)}, 0); 
        }
    }
}

module.exports = new ExportUtil();
